import React, { useState, useEffect } from "react";
import ExpandableSection from "../../expandablesection";
import Transom from "./Transom";
import TransomGlass from "./TransomGlass";
import OverallHeight from "./OverallHeight";
import TransomLite from "./TransomLite";
import LiteCollection from "./LiteCollection";
import LiteCollectionData from "./LiteCollectionData";
import TransomOption from "./TransomOption";
import TransomCasing from "./TransomCasing";
import CasingSize from "./CasingSize";
import TransomOnLoose from "./TransomOnLoose";
import { forwardRef, useImperativeHandle } from 'react';


//curently 8 components located...
//const PanelTransom = ({ onChange, doorSizeValueTriggered, doorHeightValueTriggered, passSelectedDoor }) => {
const PanelTransom = forwardRef(({ onChange, doorSizeValueTriggered, doorHeightValueTriggered, passSelectedDoor }, ref) => {
  const [transomValue, setTransomValue] = useState("");
  const [overallHeightValue, setOverallHeightValue] = useState("");
  const [transomLiteValue, setTransomLiteValue] = useState("");
  const [liteCollectionValue, setLiteCollectionValue] = useState("");
  const [liteCollectionDataValue, setLiteCollectionDataValue] = useState("");
  const [transomOptionValue, setTransomOptionValue] = useState("");
  const [transomCasingValue, setTransomCasingValue] = useState("");
  const [casingSizeValue, setCasingSizeValue] = useState("");
  const [transomOnLooseValue, setTransomOnLooseValue] = useState("");
 

  // Method to retrieve all active controls and their values
  const getActiveControlsWithValues = () => {
    const values = {};

    controlMap
      .filter((control) => control.status === "active") // Only active controls
      .forEach((control) => {
        const element = document.getElementById(control.id); // Query by control ID
        if (element) {
          values[control.id] = element.value; // Retrieve the current value
        } else {
          values[control.id] = null; // Handle missing elements
        }
      });

    return values;
  };

  // Expose the `getActiveControlsWithValues` method to the parent via ref
  useImperativeHandle(ref, () => ({
    getActiveControlsWithValues,
  }));


  // Notify parent component whenever values change
  useEffect(() => {
    onChange({
      transom: transomValue,
      overallHeight: overallHeightValue,
      transomLite: transomLiteValue,
      liteCollection: liteCollectionValue,
      liteCollectionData: liteCollectionDataValue,
      transomOption: transomOptionValue,
      transomCasing: transomCasingValue,
      transomOnLoose: transomOnLooseValue,
      casingSize: casingSizeValue,
    });
  }, [transomValue, overallHeightValue, transomLiteValue, liteCollectionValue, liteCollectionDataValue, 
      transomOptionValue, transomCasingValue,
      transomOnLooseValue, casingSizeValue, onChange]);

  // Control map specific to TransomPanel
  const controlMap = [
    {
      id: "Transom",
      component: (
        <Transom
          onChange={(newValue) => {
            setTransomValue(newValue);
          }}
          childs={["OverallHeight", "TransomGlass", "TransomLite", "TransomCasing", "TransomOnLoose" ]}
        />
      ),
      position: [1, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "OverallHeight",
      component: (
        <OverallHeight
          onChange={(newValue) => {
            setOverallHeightValue(newValue);
          }}
        />
      ),
      position: [1, 2],
      status: "active",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "TransomGlass",
      component: <TransomGlass />,
      position: [1, 3],
      status: "inactive",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "TransomLite",
      component: (
        <TransomLite
          onChange={(newValue) => {
            setTransomLiteValue(newValue);
          }}
          childs={["LiteCollection", "LiteCollectionData" ]}
          doorSizeValueToFunc={doorSizeValueTriggered} // Pass the actual prop
          doorHeightValueToFunc={doorHeightValueTriggered} // Pass the actual prop
          passSelectedDoor={passSelectedDoor} //pass selected door

        />
      ),
      position: [2, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "LiteCollection",
      component: (
        <LiteCollection
          onChange={(newValue) => {
            setLiteCollectionValue(newValue);
          }}
        />
      ),
      position: [3, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    }, 
    {
      id: "LiteCollectionData",
      component: (
        <LiteCollectionData
          onChange={(newValue) => {
            setLiteCollectionDataValue(newValue);
          }}
        />
      ),
      position: [3, 2],
      status: "active",
      expandableSectionId: "TransomPanel",
    }, 
    {
      id: "TransomOption",
      component: (
        <TransomOption
          onChange={(newValue) => {
            setTransomOptionValue(newValue);
          }}
        />
      ),
      position: [4, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    }, 
    {
      id: "TransomCasing",
      component: (
        <TransomCasing
          onChange={(newValue) => {
            setTransomCasingValue(newValue);
          }}
          childs={["CasingSize"]}
        />
      ),
      position: [5, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "CasingSize",
      component: (
        <CasingSize
          onChange={(newValue) => {
            setCasingSizeValue(newValue);
          }}
        />
      ),
      position: [5, 2],
      status: "active",
      expandableSectionId: "TransomPanel",
    },
    {
      id: "TransomOnLoose",
      component: (
        <TransomOnLoose
          onChange={(newValue) => {
            setTransomOnLooseValue(newValue);
          }}
        />
      ),
      position: [6, 1],
      status: "active",
      expandableSectionId: "TransomPanel",
    }, 
  ];
  

  return (
    <ExpandableSection
      title="Transom"
      panelLocation="113"
      controlMap={controlMap.filter((control) => control.expandableSectionId === "TransomPanel")}
    />
  );
});
//  );
//};

export default PanelTransom;
